(function () {
  'use strict';
  function enhance(section) {
    if (!section || section.dataset.mzReady) return;
    section.dataset.mzReady = 'true';
    section.classList.add('is-enhanced');
    var dialog = section.querySelector('.mz-collection-dialog');
    var opener = section.querySelector('[data-mz-filter-open]');
    var apply = section.querySelector('[data-mz-filter-apply]');
    var originalApply = apply ? apply.href : '';
    var previousOverflow = '';
    function preservePreview(link) {
      var url = new URL(link.href, location.origin);
      var current = new URL(location.href);
      ['preview_theme_id', '_fd', 'pb', '_sc'].forEach(function (key) {
        if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      });
      link.href = url.href;
    }
    section.querySelectorAll('a[href]').forEach(preservePreview);
    function close() { if (dialog && dialog.open) dialog.close(); }
    function restore() {
      document.documentElement.style.overflow = previousOverflow;
      if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus({ preventScroll: true }); }
    }
    if (dialog && opener && typeof dialog.showModal === 'function') {
      opener.setAttribute('aria-expanded', 'false');
      opener.addEventListener('click', function () {
        if (dialog.open) return;
        dialog.querySelectorAll('[data-mz-colour-link]').forEach(function (link) {
          if (link.dataset.originalCurrent === 'true') link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        if (apply) { apply.href = originalApply; preservePreview(apply); }
        previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        opener.setAttribute('aria-expanded', 'true');
        dialog.querySelector('[data-mz-filter-close]').focus();
      });
      dialog.querySelectorAll('[data-mz-filter-close]').forEach(function (button) { button.addEventListener('click', close); });
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      });
      dialog.addEventListener('close', restore);
      dialog.querySelectorAll('[data-mz-colour-link]').forEach(function (link) {
        link.dataset.originalCurrent = link.hasAttribute('aria-current') ? 'true' : 'false';
        link.addEventListener('click', function (event) {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          dialog.querySelectorAll('[data-mz-colour-link]').forEach(function (item) { item.removeAttribute('aria-current'); });
          link.setAttribute('aria-current', 'true');
          if (apply) apply.href = link.href;
        });
      });
      window.addEventListener('pagehide', function () { if (dialog.open) close(); });
      var desktop = window.matchMedia('(min-width:1008px)');
      desktop.addEventListener('change', function (event) { if (event.matches) close(); });
    } else {
      section.classList.remove('is-enhanced');
      if (opener) opener.hidden = true;
    }
    var sort = section.querySelector('[data-mz-sort]');
    if (sort) {
      function navigateSort(event) {
        if (event) event.preventDefault();
        var url = new URL(location.href);
        url.searchParams.set('sort_by', sort.elements.sort_by.value);
        url.searchParams.delete('page');
        url.searchParams.delete('view');
        location.assign(url.href);
      }
      sort.addEventListener('submit', navigateSort);
      sort.elements.sort_by.addEventListener('change', navigateSort);
    }
  }
  function start(root) { (root || document).querySelectorAll('[data-mz-collection]').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(); });
  else start();
  document.addEventListener('shopify:section:load', function (event) { start(event.target); });
}());
